export default function PHP_fetch_fields() {
  return (
    <div>
      <h1>PHP_fetch_fields</h1>
    </div>
  );
}
